module.exports = __webpack_public_path__ + "static/unity_logo-350fae9bf0210524f498bd8772da6a5e.png";